import React from "react";
import { BRAND_LOGO_SRC, BRAND_NAME } from "../../../assets/brand";
import { SecondaryButton } from "../../../components";

export default function AdminHeader({ userLogOut }) {
  return (
    <div className="admin-header">
      <div className="logo" onClick={(e) => topToPage(e)}>
        <img src={BRAND_LOGO_SRC} alt={BRAND_NAME} onClick={(e) => topToPage(e)} />
      </div>
      <div className="prompt-bottom" style={{ marginTop: 0 }}>
        <SecondaryButton label="Logout" onClick={userLogOut} />
      </div>
    </div>
  );
}
